<template>
  <div class="maimai-result">
    <!-- success -->
    <template v-if="result == true && resultShow">
      <img src="./../../assets/img/maimaisuc.png" alt="脉脉授权成功" />
      <p class="result">恭喜您脉脉认证授权成功</p>
      <div class="quit" @click="quitAuth">完成</div>
    </template>

    <!-- fail -->
    <template v-if="result == false && resultShow">
      <img src="./../../assets/img/maimaifail.png" alt="脉脉授权失败" />
      <p class="result">很遗憾脉脉认证授权失败</p>
      <p class="reason">{{ errMsg }}</p>
      <div class="quit" @click="quitAuth">退出</div>
    </template>
  </div>
</template>
<script>
import native from '@zz-common/native-adapter'
import { lego } from '@zz-common/lego'
import { getmaimairesult } from '@api/resourceApi'
import { queryParams, getCookie } from '../../lib/utils'
import isZZ from '../../lib/isZhuanZhuan.js'
const query = queryParams()
export default {
  name: 'MaimaiResult',
  data() {
    return {
      resultShow: false,
      // 成功 or 失败
      result: '',
      // 失败消息
      errMsg: ''
    }
  },
  created() {
    native.wrap('setTitle')({
      title: '脉脉认证'
    })
    if (query.u || this.$route.query.u) {
      this.getMaimaiResult()
    }
  },
  methods: {
    quitAuth() {
      isZZ && native.wrap('close')()
    },
    getMaimaiResult() {
      getmaimairesult({
        mmUid: query.u || this.$route.query.u,
        accessToken: query.t || this.$route.query.t
      })
        .then((_res) => {
          // 如果认证成功
          this.result = true
          this.resultShow = true
          // 向app发送通知
          isZZ &&
              native.wrap('sendNotification')({
                name: 'ZZ_NOTIFICATION_REAL_CERTIFICATION_SUCCESS',
                args: JSON.stringify({
                  userId: getCookie('uid')
                })
              })
          // 认证成功页 上报埋点
          lego.send({
            pagetype: 'maimaiResult',
            actiontype: 'SUCCESS'
          })
        })
        .catch((err) => {
          // 如果认证失败
          this.result = false
          this.errMsg = err.respData
          this.resultShow = true
          // 认证失败页 上报
          lego.send({
            pagetype: 'maimaiResult',
            actiontype: 'FAIL'
          })
        })
    }
  }
}
</script>

<style lang="less" scoped>
  @import './maimairesult.less';
</style>
